<template>
  <MainLayout>
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-12">
          <nav class="navbar navbar-toggleable navbar-light">
            <ul class="nav navbar-nav">
              <li class="nav-item">
                <router-link to="/reports/assignments" class="nav-link typography--body-3">{{ $t('reports.sub_header.assignments_tab') }}</router-link>
              </li>
              <li class="nav-item active">
                <router-link to="/reports/classes" class="nav-link typography--body-3">{{ $t('reports.sub_header.classes_tab') }}</router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <div class="container mw-960 mt-27" slot="layout-body">
      <div class="row">
        <div class="col-12 text-center mb-5 pb-5" v-if="managingClassList.length === 0">
          <div class="empty-list-text">
            <div class="typography--body-2 typography--color-disabled"
                 v-html="$t('classes.no_classes')">
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg-3" v-for="cls in managingClassList" v-bind:key="cls.id" v-else>
          <div class="card-row">
            <ClassItem v-bind:cls="cls" />
          </div>
        </div>
      </div>
    </div>

  </MainLayout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ClassItem from '../components/ClassItem';

  export default {
    name: 'classes',

    components: {
      ClassItem,
    },

    computed: {
      ...mapGetters([
        'managingClassList',
      ]),
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/classes/views/Classes.vue